export const BIDS_PER_JOB_ANALYSIS_EARLIEST_DATE = new Date(2022, 0, 1)

export type BidsPerJobAnalysisPeriod = 'last30' | 'last60' | 'last90' | 'last120' | 'custom'

export const BIDS_PER_JOB_ANALYSIS_TIME_PERIODS: {
  value: BidsPerJobAnalysisPeriod
  label: string
}[] = [
  { value: 'last30', label: 'Last 30 days' },
  { value: 'last60', label: 'Last 60 days' },
  { value: 'last90', label: 'Last 90 days' },
  { value: 'last120', label: 'Last 120 days' },
  { value: 'custom', label: 'Custom' },
]

export const BIDS_PER_JOB_ANALYSIS_CHART_HEIGHT = 340
